import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function NoRiskSection() {
  return (
    <section
      data-testid="no-risk-section"
      className="py-20 sm:py-24 px-6 sm:px-12 lg:px-24"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6 }}
        className="max-w-5xl mx-auto rounded-3xl border border-blue-500/30 bg-gradient-to-br from-blue-600/10 to-blue-600/5 p-12 sm:p-16 text-center relative overflow-hidden"
      >
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(37,99,235,0.08),transparent_70%)]" />
        <div className="relative z-10">
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-white mb-4">
            No Risk — Try It
          </h2>
          <p className="text-lg text-neutral-400 mb-8 max-w-xl mx-auto leading-relaxed">
            There's zero cost to join. No contracts, no obligations. If it doesn't work for you,
            walk away anytime. But we think you'll love the extra revenue.
          </p>
          <a
            href="#contact"
            data-testid="no-risk-cta-button"
            className="inline-flex items-center gap-3 bg-blue-600 hover:bg-blue-500 text-white rounded-full px-8 py-4 transition-all duration-300 transform hover:-translate-y-1 shadow-[0_0_20px_rgba(37,99,235,0.3)] hover:shadow-[0_0_30px_rgba(37,99,235,0.5)] font-bold text-sm tracking-wide"
          >
            Become a Partner <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </motion.div>
    </section>
  );
}
